import React, { useCallback, useMemo } from 'react'

import { Stack, Text } from '@chakra-ui/react'
import { useField } from 'formik'
import { useSelector } from 'react-redux'

import BaseArrayField from './BaseArrayField'
import SelectedGroup from './SelectedGroup'
import { PERMISSIONS } from '../../../../../constants/permissions/constituents'
import { convertDistrictToNumeric, hasPermission } from '../../../../../utils'
import { ConstituentGroupSelect } from '../../../../ui/select'

const GroupsField = ({ field, district }) => {
  const [formikField, , helpers] = useField(field)
  const user = useSelector(state => state.auth.user)
  const { value: groups } = formikField
  const { setValue } = helpers
  const onRemoveGroup = useCallback(
    removeIndex => setValue(groups.toSpliced(removeIndex, 1)),
    [setValue, groups]
  )

  const onRoleChange = useCallback(
    (index, value) => {
      let updatedGroups = [...groups]
      updatedGroups[index] = { ...updatedGroups[index], role: value }
      setValue(updatedGroups)
    },
    [setValue, groups]
  )

  const selectedGroups = useMemo(
    () => groups?.map(group => ({ label: group.name, value: group })) || [],
    [groups]
  )

  return (
    <>
      <BaseArrayField field={field} label='Groups'>
        {({ onSelect, onClear }) => (
          <>
            {hasPermission(user, PERMISSIONS.VIEW_ALL_CONSTITUENTS) &&
              district && (
                <Text variant='subheading-sm'>
                  Group choices limited to District&nbsp;
                  {convertDistrictToNumeric(district)}
                </Text>
              )}
            <ConstituentGroupSelect
              district={district}
              onSelect={onSelect}
              onClear={onClear}
              initialSelected={selectedGroups}
              showTags={false}
              inputProps={{
                id: 'group-select',
                placeholder: 'Search for an existing group in district',
              }}
            />
          </>
        )}
      </BaseArrayField>
      {groups.length > 0 && (
        <Stack gap={0.5}>
          {groups.map((group, index) => (
            <SelectedGroup
              key={index}
              index={index}
              {...group}
              onRoleChange={onRoleChange}
              onRemove={onRemoveGroup}
            />
          ))}
        </Stack>
      )}
    </>
  )
}

export default GroupsField
